import React, { useState, useEffect } from 'react';
import { useAuth } from '../services/authContext';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';
import AuthModal from './AuthModal';

function Navbar() {
  const { user, logout, loading } = useAuth();
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [showAuth, setShowAuth] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  // Helper to handle login/signup open and close menu
  const handleShowAuth = () => {
    setShowAuth(true);
    closeMobileMenu();
  };


  useEffect(() => {
    showButton();
    window.addEventListener('resize', showButton);
    return () => window.removeEventListener('resize', showButton);
  }, []);

  // Helper to handle logout and close menu
  const handleLogout = () => {
    logout();
    closeMobileMenu();
  };

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
            <img src="https://ubnsbjqmjwgoyqlyhmuf.supabase.co/storage/v1/object/public/public-assets/IMG_0136.jpg" alt="PP" className="navbar-logo-img" />
            PRICE PERFECT
          </Link>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li className='nav-item'>
              <Link to='/products' className='nav-links' onClick={closeMobileMenu}>
                Trending
              </Link>
            </li>
            <li className='nav-item'>
              <Link to='/services' className='nav-links' onClick={closeMobileMenu}>
                Browse
              </Link>
            </li>
            <li className='nav-item'>
              <Link to='/blog/fashion-shopping-deals-2025' className='nav-links' onClick={closeMobileMenu}>
                Blog
              </Link>
            </li>
            {user ? (
              <li>
                <button className='nav-links-mobile' onClick={handleLogout}>Logout</button>
              </li>
            ) : (
              <li>
                <button className='nav-links-mobile' onClick={handleShowAuth}>Login / Sign Up</button>
              </li>
            )}
          </ul>
          <div className="navbar-right">
            {user ? (
              <div className="navbar-userblock">
                {user.firstName && user.lastName && (
                  <Link to="/profile" className="navbar-initials-link" title="View Profile">
                    <span className="navbar-initials">
                      {user.firstName[0].toUpperCase()}{user.lastName[0].toUpperCase()}
                    </span>
                  </Link>
                )}
                <Button buttonStyle='btn--outline' onClick={handleLogout}>
                  LOGOUT
                </Button>
              </div>
            ) : (
              button && (
                <div className="navbar-userblock">
                  <Button buttonStyle='btn--outline' onClick={handleShowAuth}>
                    LOGIN / SIGN UP
                  </Button>
                </div>
              )
            )}
            <div className='menu-icon' onClick={handleClick}>
              <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
            </div>
          </div>
          <AuthModal isOpen={showAuth} onClose={() => setShowAuth(false)} />
        </div>
      </nav>
    </>
  );
}

export default Navbar;
